import { ReactElement, useState } from 'react'
import { StyleProp, StyleSheet, View, ViewProps, ViewStyle } from 'react-native'
import { Trans } from 'react-i18next'
import { Color, Radius, Spacing, Text } from 'zens-storybook'

import FilterUnfold from './unfold'

const styles = StyleSheet.create({
  container: {
    backgroundColor: Color.simplyWhite,
    borderRadius: Radius.M,
    paddingHorizontal: Spacing.S,
  },
  content: {
    flex: 1,
    flexDirection: 'row',
    flexWrap: 'wrap',
    paddingTop: Spacing.S,
    paddingBottom: Spacing.S,
  },
  empty: {
    color: Color.metalGrey,
  },
  skeleton: {
    minHeight: 38,
  },
})

interface Props extends ViewProps {
  value?: ReactElement
  loading?: boolean
  contentContainerStyle?: StyleProp<ViewStyle>
}

const FilterPanel = (props: Props) => {
  const { value, loading, children, contentContainerStyle, style, ...otherProps } = props
  const [unfolded, setUnfolded] = useState(false)

  return (
    <View style={[styles.container, style]} {...otherProps}>
      <FilterUnfold unfolded={unfolded} onPress={() => setUnfolded(!unfolded)} loading={loading}>
        {value ?? (
          <Text style={styles.empty}>
            <Trans>No filters</Trans>
          </Text>
        )}
      </FilterUnfold>

      {unfolded && <View style={[styles.content, contentContainerStyle]}>{children}</View>}
    </View>
  )
}

interface SkeletonProps extends ViewProps {}

FilterPanel.Skeleton = (props: SkeletonProps) => {
  const { style, ...otherProps } = props
  return <View style={[styles.container, styles.skeleton, style]} {...otherProps} />
}

export default FilterPanel
